module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"store":"ストア","type_store":"タイプストア","no_result":"検索結果はありません. 入力してストアを検索します."}}')
  delete Component.options._Ctor
}
